import 'alpinejs';

require('./mistakes');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Vue = require('vue');

window.EventBus = new Vue();

Vue.component('attributes-tree', require('./components/admin/AttributesTree').default);

Vue.component('product-filter', require('./components/ProductFilter').default);
Vue.component('price-range', require('./components/PriceRange').default);
Vue.component('catalog-tool-bar', require('./components/CatalogToolBar').default);
Vue.component('cart', require('./components/Cart').default);
Vue.component('checkout', require('./components/Checkout').default);
Vue.component('autocomplete', require('./components/Autocomplete').default);
Vue.component('back-to-top', require('./components/BackToTop').default);
Vue.component('editable', require('./components/Editable').default);
Vue.component('editable-publish', require('./components/EditablePublish').default);
Vue.component('editable-editor', require('./components/EditableEditor').default);
Vue.component('load-more', require('./components/LoadMore').default);
Vue.component('search', require('./components/Search').default);


const app = new Vue({
    el: '#back-to-top',
    data:{
        msg:'Vue',
    }
});
